import React from 'react';

import { useIntl } from 'react-intl';

import { ILoyaltyTransaction } from '@rbi-ctg/menu';

import {
  Divider,
  StyledLoyaltyPointsIcon,
  Total,
  TotalLabel,
  TotalsRow,
} from './modal-order-details.styled';

export const OrderRewardDetails = ({
  loyaltyTransaction,
}: {
  loyaltyTransaction: ILoyaltyTransaction;
}) => {
  const { formatMessage } = useIntl();
  const { pointsBalance, pointsUsed } = loyaltyTransaction;

  return (
    <>
      {/* Available Points */}
      <TotalsRow>
        <TotalLabel>{formatMessage({ id: 'availablePoints' })}</TotalLabel>
        <Total marginRight="$1">{pointsBalance}</Total>
        <StyledLoyaltyPointsIcon />
      </TotalsRow>

      {/* Redeeming */}
      <TotalsRow marginTop="$2">
        <TotalLabel>{formatMessage({ id: 'redeeming' })}</TotalLabel>
        <Total marginRight="$1">{-(pointsUsed || 0)}</Total>
        <StyledLoyaltyPointsIcon />
      </TotalsRow>

      <Divider />
    </>
  );
};
